import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { env } from '@/config/env'
import { useAuthContext } from '@/features/auth/hooks/use-auth-context'

export function useMaintenance() {
  const { user, session, isLoading } = useAuthContext()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading) return

    if (!session) {
      navigate('/login', { replace: true })
    } else {
      if (!user?.isSuperAdmin && env.isMaintenance) {
        navigate(`/in-maintenance`, { replace: true })
      }
    }
  }, [session, isLoading, navigate, user?.isSuperAdmin])
}
